import React, { useContext, useEffect, useState } from "react";
// React Router
import { useParams } from "react-router-dom";
// Componentes
import MisionInfo from "./MisionInfo";
import InfoMision from "./desplegables/InfoMision";
import Juridicos from "./desplegables/Juridicos";
import Educativos from "./desplegables/Educativos";
import Economicos from "./desplegables/Economicos";
import Espiritualidad from "./desplegables/Espiritualidad";
import Personal from "./desplegables/Personal";
import Actividades from "./desplegables/Actividades";
import Ambitos from "./desplegables/Ambitos";
import PersonasAtendidas from "./desplegables/PersonasAtendidas";
import DescripcionObra from "./desplegables/DescripcionObra";
import DescripcionProyecto from "./desplegables/DescripcionProyecto";
import MisionGaleria from "./MisionGaleria";
import MisionDocumentos from "./MisionDocumentos";
import Cargos from "../../cargos/Cargos";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";
// Contexto
import { AlertBoxContext } from "../../../context/alertBoxContext";
import { ModalContext } from "../../../context/modalContext";
import { categoriaMisiones } from "../../../contexto";
// jquery
import $ from "jquery";
// React Bootstrap
import { Accordion, Button, Card, Container, Tab, Tabs, Row } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTabs = styled(Tabs)`
  border-bottom: 0px;
`;

const MisionDetalle = ({ userLevel, ...props }) => {
  //TODO
  let { id_m, id_p } = useParams();
  const idMision = id_m;
  const idProvincia = id_p;

  // Contexto
  const { modalSetShow } = useContext(ModalContext);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  // Datos de la misión
  const [datosMision, setDatosMision] = useState({});
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // UEF para llamar a los datos de la misión

  useEffect(() => {
    handleGetDatosMision();
  }, []);

  //********************************************** REQUESTS ****************************************************
  // Obtiene los datos de la misión
  const getDatosMision = () => {
    //console.log(`${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}`)
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos de la misión
  const putDatosMision = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Edita los datos de una misión que sea una obra
  const putDatosMisionObra = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}/obra`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Edita los datos de una misión de tipo educativa
  const putDatosProyecto = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}/proyecto`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  //********************************************** HANDLERS ****************************************************/
  // Manejador para obtener los datos de la misión
  const handleGetDatosMision = () => {
    setLoading(true);
    getDatosMision()
      .then((response) => {
        setLoading(false);
        setDatosMision(response);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos de la misión
  const handlePutDatosMision = (data) => {
    setLoading(true);
    modalSetShow(false);
    putDatosMision(data)
      .then((response) => {
        setLoading(false);
        setDatosMision(response);
        addAlert("Exito", "Se han editado los datos de la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos de una misión obra
  const handlePutMisionObra = (data) => {
    setLoading(true);
    modalSetShow(false);
    putDatosMisionObra(data)
      .then(() => {
        setLoading(false);
        let miDatosMision = datosMision;
        miDatosMision.work = { ...miDatosMision.work, ...data };
        setDatosMision(miDatosMision);
        addAlert("Exito", "Se han editado los datos de la misión correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos educativos de una mision
  const handlePutMisionProyecto = (data) => {
    setLoading(true);
    modalSetShow(false);

    putDatosProyecto(data)
      .then(() => {
        setLoading(false);
        let miDatosMision = datosMision;
        miDatosMision.project = { ...miDatosMision.project, ...data };
        setDatosMision(miDatosMision);
        addAlert("Exito", "Se ha editado correctamente la descripción del proyecto", "success");
      })
      .catch(() => {
        setLoading(false);
        // props?.ErrorHandling()
      });
  };

  //********************************************** UTILS ****************************************************/
  // En función de la categoria d la misión se devuelve un tipo u otro de equipo directivo
  const getTipoEquipoDirectivo = () => {
    switch (datosMision?.category) {
      case "Educativo":
        return "equiposDirectivosEducativo";
      case "Alojamiento":
        return "equiposDirectivosAlojamiento";
      case "Sanitario":
        return "equiposDirectivosSalud";
      case "CasaEspiritualidad":
        return "equiposDirectivosEspiritualidad";
      case "Social":
        return "equiposDirectivosSocial";
      default:
        return "equiposDirectivosEducativo";
    }
  };

  //************************************************ RETURN *****************************************************/
  return (
    <Container className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />
      <MisionInfo datosMision={datosMision} idProvincia={idProvincia} />
      {<MisionGaleria idProvincia={idProvincia} idMision={idMision} loading={loading} setLoading={setLoading} permisoEdicion={userLevel >= 10 ? true : false} />}
      {/*{!datosMision.isCollaborative && <MisionGaleria idProvincia={idProvincia} idMision={idMision} loading={loading} setLoading={setLoading} permisoEdicion={userLevel >= 10 ? true : false} />} */}
      {userLevel >= 9 &&
        <CustomTabs>
          <Tab
            eventKey={`Información ${datosMision?.type === "Obra" ? `de la ${datosMision?.type}` : `del ${datosMision?.type}`}`}
            title={`Información ${datosMision?.type === "Obra" ? `de la ${datosMision?.type}` : `del ${datosMision?.type}`}`}
          >
            <InfoMision datosMision={datosMision} handlePutDatosMision={handlePutDatosMision} />
            {!datosMision.isCollaborative && categoriaMisiones[datosMision?.category] === categoriaMisiones["Educativo"] && <Educativos idProvincia={idProvincia} idMision={idMision} />}
            {!datosMision.isCollaborative && categoriaMisiones[datosMision?.category] === categoriaMisiones["CasaEspiritualidad"] && (
              <Espiritualidad idProvincia={idProvincia} idMision={idMision} datosMisionObra={datosMision.work} handlePutMisionObra={handlePutMisionObra} />
            )}
            {!datosMision.isCollaborative &&
              (categoriaMisiones[datosMision?.category] === categoriaMisiones["Sanitario"] || categoriaMisiones[datosMision?.category] === categoriaMisiones["Social"]) && (
                <PersonasAtendidas idProvincia={idProvincia} idMision={idMision} />
              )}
            {!datosMision.isCollaborative && datosMision?.type === "Obra" && <Personal idProvincia={idProvincia} idMision={idMision} categoriaMision={datosMision.category} />}
            {/* Provisional hasta que hagamos los equipos directivos */}
            {!datosMision.isCollaborative && datosMision?.type === "Obra" && (
              <Accordion>
                <Card>
                  <Card.Header>
                    <Accordion.Toggle as={Button} eventKey={100} variant="link">
                      Equipo directivo
                    </Accordion.Toggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={100}>
                    <Card.Body>
                      {/* Falta hacer función que envie un tipo u otro en función del tipo de la misión */}
                      <Cargos idEntidad={idProvincia} idSubEntidad={idMision} type={getTipoEquipoDirectivo()} />
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            )}

{
//112022 para añadir Hermanas que trabajan en la obra
}
{!datosMision.isCollaborative && (
  <Accordion>
    <Card>
      <Card.Header>
        <Accordion.Toggle as={Button} eventKey={101} variant="link">
          Hermanas que trabajan en la obra
        </Accordion.Toggle>
      </Card.Header>
      <Accordion.Collapse eventKey={101}>
        <Card.Body>
          {/* Falta hacer función que envie un tipo u otro en función del tipo de la misión */}
          <Cargos idEntidad={idProvincia} idSubEntidad={idMision} type={'hermanasQueTrabajanObraOProyecto'} />
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  </Accordion>
)}

            {datosMision?.type === "Obra" && categoriaMisiones[datosMision?.category] === categoriaMisiones["Social"] && (
              <Actividades idProvincia={idProvincia} idMision={idMision} categoriaMision={datosMision.category} />
            )}
            {datosMision?.type === "Obra" && <Ambitos idProvincia={idProvincia} idMision={idMision} categoriaMision={datosMision.category} />}
          </Tab>

          {!datosMision.isCollaborative && datosMision?.type === "Obra" && (
            <Tab eventKey="Datos jurídicos" title="Datos jurídicos">
              <Juridicos idProvincia={idProvincia} idMision={idMision} datosMisionObra={datosMision?.work} handlePutMisionObra={handlePutMisionObra} />
            </Tab>
          )}

          {!datosMision.isCollaborative && datosMision?.type === "Proyecto" && (
            <Tab eventKey="Descripción del Proyecto" title="Descripción del Proyecto">
              <DescripcionProyecto datosMisionProyecto={datosMision?.project} handlePutMisionProyecto={handlePutMisionProyecto} />
              <Actividades idProvincia={idProvincia} idMision={idMision} categoriaMision={datosMision.category} />
            </Tab>
          )}
          {!datosMision.isCollaborative && (
            <Tab eventKey="Datos económicos" title="Datos económicos">
              <Economicos idProvincia={idProvincia} idMision={idMision} datosMision={datosMision} handlePutDatosMision={handlePutDatosMision} />
            </Tab>
          )}
          {datosMision?.type === "Obra" && (
            <Tab eventKey="Descripción de la Obra" title="Descripción de la Obra">
              {datosMision?.type === "Obra" && <DescripcionObra descripcionMision={datosMision?.description} handlePutDatosMision={handlePutDatosMision} />}
            </Tab>
          )}
          <Tab eventKey="Documentos" title="Documentos">
            <MisionDocumentos
              idProvincia={idProvincia}
              idMision={idMision}
              canAddConvenio={async () => {
                let misDatosMision = await getDatosMision();
                return !misDatosMision?.convenio;
              }}
            />
          </Tab>
        </CustomTabs>
      }
      {(userLevel === 2 || userLevel === 3 ) &&
        <>
          <h4>Descripción</h4>
          <Container>
            <h6 className="mt-3">
              {datosMision?.description ? datosMision.description : 'No hay descripción'}
            </h6>

          </Container>
        </>
      }
    </Container>
  );
};

export default MisionDetalle;
